import React from 'react';
import { Box, Text, VStack, HStack } from '@chakra-ui/react';

const Timestamps = ({ task }) => {
  const formatDate = (dateString) => {
    if (!dateString || dateString === '1970-01-01T00:00:00Z') return 'Not set';

    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    } catch {
      return 'Invalid date';
    }
  };

  return (
    <Box>
      <VStack align="stretch" spacing={3}>
        <HStack justify="space-between">
          <Text fontSize="12px" color="#6B778C">Created</Text>
          <Text fontSize="12px" color="#172B4D">
            {formatDate(task?.createdAt)}
          </Text>
        </HStack>

        <HStack justify="space-between">
          <Text fontSize="12px" color="#6B778C">Updated</Text>
          <Text fontSize="12px" color="#172B4D">
            {formatDate(task?.updatedAt)}
          </Text>
        </HStack>

        <HStack justify="space-between">
          <Text fontSize="12px" color="#6B778C">Created By</Text>
          <Text fontSize="12px" color="#172B4D">
            {task?.createdBy?.name || 'Unknown'}
          </Text>
        </HStack>
      </VStack>
    </Box>
  );
};

export default Timestamps;